import {
  MnemonicLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { MorphemeMnemonicsViewSuspense } from "#morpheme-mnemonics-view-suspense";
import type { BrowseMnemonicTabsProps } from "#browse-mnemonic-tabs-props";
import type { ReactElement } from "react";

export interface GraphemePageTabs {
  contentTopInset: number;
  details: () => ReactElement;
  isDetailsSelected: boolean;
  /** Reject selection acknowledgements from a detached native page. */
  onDetailsChange: (selected: boolean) => boolean;
  pagerTopExtension: number;
  renderTabBar: NonNullable<BrowseMnemonicTabsProps["renderTabBar"]>;
  swipeEnabled: boolean;
}

export function MorphemeMnemonicsView({
  initialPinyin,
  onFirstTabChange,
  pageTabs,
  rawGrapheme,
  readingNavigation = "card",
}: {
  /**
   * Open on this reading's tab (tone-number pinyin) instead of the meaning tab. Takes precedence
   * over the route's `pinyin` search param, which a host that is not a route of its own (the
   * Learn deck) cannot rely on.
   */
  initialPinyin?: string;
  // Android: reports whether the inner pager is on its first (meaning) tab so the
  // parent panel can enable its outer back-swipe to info only there.
  onFirstTabChange?: (isOnFirstTab: boolean) => void;
  pageTabs?: GraphemePageTabs;
  rawGrapheme: string;
  readingNavigation?: "card" | "browse";
}) {
  return (
    <SuspensePageBoundary fallback={<MnemonicLayoutSkeleton />} location={import.meta.location}>
      <MorphemeMnemonicsViewSuspense
        initialPinyin={initialPinyin}
        onFirstTabChange={onFirstTabChange}
        pageTabs={pageTabs}
        rawGrapheme={rawGrapheme}
        readingNavigation={readingNavigation}
      />
    </SuspensePageBoundary>
  );
}
